export default "__VITE_ASSET__mbYIb_dz__"